// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__btn{display:flex;align-items:center;padding:6px 6px}.styles-module__iconDisabled{cursor:not-allowed}
`, "",{"version":3,"sources":["webpack://./components/ui/icons/styles.module.scss"],"names":[],"mappings":"AAAA,oBACE,YAAa,CACb,kBAAmB,CACnB,eAAgB,CACjB,6BAGC,kBAAmB","sourcesContent":[".btn {\n  display: flex;\n  align-items: center;\n  padding: 6px 6px;\n}\n\n.iconDisabled {\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `styles-module__btn`,
	"iconDisabled": `styles-module__iconDisabled`
};
export default ___CSS_LOADER_EXPORT___;
